import React, { FC } from 'react';
import TableRow from '../table-row/table-row';

type Props = {
    columnDefinitions: any[],
    rows: any[],
    selectRows: boolean,
    onSelect: (index: number) => void,
    onRowClicked?: (rowData: any) => void,
    customHighlightRow?:any
    tableId?: string
    customRowColourWithRange?: any
    rowPath?: string,
    isStriped?: boolean
}

const TableBody: FC<Props> = ({ columnDefinitions = [], rows = [], selectRows = false, onSelect = () => { }, onRowClicked, customHighlightRow, tableId,  customRowColourWithRange, rowPath, isStriped = true}) => {
    const checkHiglightRow = (item) => {
        if (customHighlightRow) {
            return (item.data[customHighlightRow?.fieldName] === customHighlightRow?.comparisonValue ? true : false)
        }
        return false;
    }

    const checkCustomRowColour = (item) => {
        if (customRowColourWithRange) {
            return (item.data[customRowColourWithRange?.fieldName] === customRowColourWithRange?.comparisonValue ? true : false)

        }
        return false;
    }

    return (<>
        <tbody>
            {
                rows.map((item, index) => (
                    <TableRow
                        columnDefinitions={columnDefinitions}
                        key={`row-${index}`}
                        rowData={item.data}
                        isSelected={selectRows ? item.selected : undefined}
                        onRowClicked={onRowClicked}
                        isRowHighlighted={checkHiglightRow(item)}
                        onSelect={() => onSelect(index)}
                        tableId={tableId}
                        customRowColourWithRange={customRowColourWithRange}
                        showCustomRowColour={checkCustomRowColour(item)}
                        rowPath={rowPath}
                        isStriped={isStriped && index % 2 != 0}
                        rowIndex={index}
                        testId={index}
                    />
                ))
            }
        </tbody>
    </>);
}

export default TableBody;